import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import VirtualizedSelect from 'react-virtualized-select';
import theme from '../../../themes/green';

const StyledSelect = styled(VirtualizedSelect)`
  &:focus {
    outline: none;
  }

  & .Select-control {
    border-color: ${theme.pallete.lightBackground};
    border-radius: 0;
    border: 2px solid ${theme.pallete.lightBackground};
    font-size: 10pt;
  }

  &.is-focused:not(.is-open) .Select-control {
    border: 2px solid ${theme.pallete.color};
  }

  & .Select-menu-outer {
    border: 2px solid ${theme.pallete.lightBackground};
    border-top: none;
  }

  & .VirtualizedSelectOption {
    font-size: 10pt;
    cursor: pointer;
  }

  & .VirtualizedSelectOption:hover {
    background-color: ${theme.pallete.hover};
  }

  & .VirtualizedSelectFocusedOption {
    background-color: ${theme.pallete.hover};
  }

  & .VirtualizedSelectDisabledOption {
    opacity: 0.5;
  }

  & .VirtualizedSelectSelectedOption {
    font-weight: inherit;
    background-color: ${theme.pallete.color};
  }
`;

class Select extends React.Component {
  constructor(props) {
    super();
    this.state = {
      value: props.value,
    };

    this.onChange = this.onChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      value: nextProps.value,
    });
  }

  onChange(value) {
    this.setState({ value }, () => {
      this.props.onChange(value);
    });
  }

  render() {
    const { onChange, options, value, error, showRequired, ...rest } = this.props;
    const className = `${error && showRequired ? 'hasError' : ''}`;

    return (
      <StyledSelect
        className={className}
        options={options}
        simpleValue
        onChange={this.onChange}
        value={this.state.value}
        {...rest}
      />
    );
  }
}

Select.propTypes = {
  options: PropTypes.array,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChange: PropTypes.func,
};

Select.defaultProps = {
  options: [],
  value: null,
  onChange: () => {},
};

export default Select;



// WEBPACK FOOTER //
// ./src/components/UIKit/Select/index.js